export const sortByNumericSuffix = (files: string[]) => {
  return [...files].sort((a, b) => {
    const getNum = (val: string) => {
      const parts = val.split('.');
      const last = parts[parts.length - 1];
      const num = Number(last);
      return Number.isNaN(num) ? 0 : num;
    };
    const numA = getNum(a);
    const numB = getNum(b);
    if (numA === numB) return a.localeCompare(b);
    return numA - numB;
  });
};

export const getCoverUrl = (id: number, ext = "webp") => `/projects/${id}/images/Cover${id}.${ext}`;
export const getImageUrl = (id: number, file: string, ext = "webp") => `/projects/${id}/images/${file}.${ext}`;
export const getVideoUrl = (id: number, file: string, ext: string) => `/projects/${id}/videos/${file}.${ext}`;
export const getPanoUrl = (id: number, file: string, ext = "webp") => `/projects/${id}/panos/${file}.${ext}`;
